export function isIE() {
    return (
        window.navigator &&
        window.navigator.userAgent &&
        window.navigator.userAgent.indexOf("Trident/7.0") > -1
    );
}
